import { CLIENT_UPDATE, CLIENT_REMOVE } from './client.actions';
import { PATIENT_LOGGED_OUT } from '../patient/patient.actions';

const clientReducer = (state = null, action) => {
    switch (action.type) {
        case CLIENT_UPDATE:
            return action.value;
        case CLIENT_REMOVE:
        case PATIENT_LOGGED_OUT:
            return null;
        default:
            return state;
    }
}

export default clientReducer;